import React from 'react';
import styled from 'styled-components';

var Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1100;
`;

var Popup = styled.div`
  position: fixed;
  background: white;
  color: black;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  padding: 4px 0;
  z-index: 1101;
  min-width: 180px;
`;

var MenuItem = styled.button`
  display: block;
  width: 100%;
  background: none;
  border: none;
  padding: 8px 12px;
  font-size: 0.8rem;
  color: black;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;

  &:hover {
    background: #f0f0f0;
  }
`;

function clampPos(x, y) {
  var vw = window.innerWidth;
  var vh = window.innerHeight;
  var left = Math.max(8, Math.min(x, vw - 196));
  var top = Math.max(8, Math.min(y - 80, vh - 100));
  return { left: left, top: top };
}

/**
 * Play/Queue popup menu.
 * Props:
 *   pos: { x, y } - screen coordinates to anchor the menu
 *   onClose: () => void
 *   onPlayNow: () => void
 *   onAddToQueue: () => void
 */
function PlayQueueMenu(props) {
  var pos = clampPos(props.pos.x, props.pos.y);

  return (
    <>
      <Overlay onClick={props.onClose} />
      <Popup style={{ left: pos.left, top: pos.top }}>
        <MenuItem
          onClick={function () {
            props.onClose();
            props.onPlayNow();
          }}
        >
          Play Now
        </MenuItem>
        <MenuItem
          onClick={function () {
            props.onClose();
            props.onAddToQueue();
          }}
        >
          Add to Queue
        </MenuItem>
      </Popup>
    </>
  );
}

export default PlayQueueMenu;
